// extracted by mini-css-extract-plugin
export default {"main":"Header_main__dfMf-","heading":"Header_heading__WGQQQ"};